import axios from 'axios'
import updatePriority from 'gatsby-theme-frontier/src/utils/updatePriority'

export default async function zipLogic(zipCode, isSpanishPage) {
  try {
    const datasetUrl = `https://dm.clear.link/api/datasets/frontier-zip-list/find?search[Zip]=${zipCode}`

    const zipSubmissionData = await axios.get(datasetUrl, {
      headers: {
        'X-Api-Key': '358ea773800344e78f353d315727621b',
      },
    })

    const zipData = zipSubmissionData?.data?.dataset?.data
      ? zipSubmissionData?.data?.dataset?.data[0]
      : null

    const productGroup = zipData?.Product_Group

    const packageDatasetUrl = `https://dm.clear.link/api/datasets/frontier-product-groups/find?search[Product_Group]=${productGroup}`
    const packageSubmissionData = await axios.get(packageDatasetUrl, {
      headers: {
        'X-Api-Key': '358ea773800344e78f353d315727621b',
      },
    })

    const packageNames = packageSubmissionData?.data?.dataset?.data
      ? packageSubmissionData?.data?.dataset?.data[0]
      : null

    if (zipData && productGroup !== 'OOA') {
      const { data } = await axios.get(
        'https://brandy.clear.link/data/brand/ftr'
      )

      const packagesToShow = []
      const disclaimersToShow = []

      const currentUrl = window.location.href

      Object.entries(packageNames).forEach(([key, value]) => {
        if (key.startsWith('Product_Group')) {
          return
        }

        const possiblyModifiedValue = currentUrl.includes('/es')
          ? `${value}-es`
          : value

        if (/Product_\d+/.test(key)) {
          packagesToShow.push(possiblyModifiedValue)
        }

        // Format: Disclaimer_[number]
        if (/Disclaimer_\d+/.test(key)) {
          disclaimersToShow.push(possiblyModifiedValue)
        }
      })

       
      const allDisclaimers = disclaimersToShow.map(function (disclaimer) {
        const { attributes } = data.brand_data.FTR

        if (!attributes) {
          console.error(`No attributes found for disclaimer ${disclaimer}`)  
          return null
        }

        const disclaimerText = attributes[disclaimer]
        const disclaimerSymbol = attributes[`${disclaimer}${'-symbol'}`] || null

         
        return {
          text: disclaimerText,
          symbol: disclaimerSymbol,
        }
      })

      const packageSectionData = []

      packagesToShow.forEach((currentPackage) => {
         
        const attributes = data?.data?.[`${currentPackage}`]?.attributes

        if (!attributes) {
          console.error(`No attributes found for package ${currentPackage}`)
          return
        }

        const name = data?.data?.[`${currentPackage}`]?.name
        const allBulletKeyReferences = []
        const bulletKeysArray = Object?.keys(attributes)
        bulletKeysArray?.map(
          (key) =>
            key?.includes('bullets-attributes') &&
            allBulletKeyReferences.push(key)
        )

        const bullets = Object?.keys(attributes)
          ?.filter(
            (attrKey) =>
              attrKey.startsWith('bullets-') && !attrKey.endsWith('-disclaimer')
          )
          ?.map((bulletKey) => {
            const bulletObj = {
              text: attributes?.[bulletKey],
            }
            const bulletIdentifier = bulletKey?.replace('bullets-', '')
            const disclaimerText =
              attributes?.[`bullets-${bulletIdentifier}-disclaimer`]
            const disclaimerSymbol =
              attributes?.[`bullets-${bulletIdentifier}-disclaimer-symbol`]
            if (disclaimerText) {
              bulletObj.disclaimer = {
                text: disclaimerText,
                symbol: disclaimerSymbol,
              }
            }
            return bulletObj
          })

        const packageData = {
          label: '',
          packageName: currentPackage,
          brandy: {
            name,
            bullets,
            price: {
              custom: `${attributes['pricing-custom'] || ''}`,
              duration: `${attributes['pricing-duration'] || ''}`,
              before: `${attributes['pricing-before'] || ''}`,
              amount: `${attributes['pricing-amount'] || ''}`,
              disclaimer: {
                text: `${attributes['pricing-disclaimer']}`,
              },
            },
          },
        }

        packageSectionData.push(packageData)
      })

      updatePriority(isSpanishPage ? 631 : 626)

      return {
        packages: packageSectionData,
        disclaimers: allDisclaimers,
      }
    } else {
      updatePriority(isSpanishPage ? 630 : 625)

      return {
        packages: [],
      }
    }
  } catch (err) {
    // error occurred
    console.log(err)
    return null
  }
}
